import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "debit-payment-confirmation item-content mb-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "item-secondary-title mb-1" }, "Direct debit and terms and conditions acceptance", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Please read and acknowledge the direct debit authority & conditions.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Your first premium must be paid within 14 days from accepting the cover.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " If you would like to change your premium frequency please contact us at least 2 days before your premium is due. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SummaryCard = _resolveComponent("SummaryCard")!
  const _component_PaymentDetailsCard = _resolveComponent("PaymentDetailsCard")!
  const _component_SpecificConditions = _resolveComponent("SpecificConditions")!
  const _component_ConditionsOfThisAuthority = _resolveComponent("ConditionsOfThisAuthority")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_SummaryCard, {
      title: "Your direct debit details",
      items: _ctx.directDebitItems,
      "is-mobile-screen": _ctx.isMobileScreen
    }, null, 8, ["items", "is-mobile-screen"]),
    _hoisted_4,
    (_ctx.shouldShowPaymentDetailsCard)
      ? (_openBlock(), _createBlock(_component_PaymentDetailsCard, {
          key: 0,
          "payment-amount": _ctx.premiumAmount,
          "existing-payment-amount": _ctx.existingPremiumSum,
          "first-premium-date": _ctx.policy.firstPremiumDate,
          "next-premium-date": _ctx.policy.nextPremiumDate,
          "benefit-renewal-date": _ctx.policy.policyBenefits[0]?.policyBenefitPremiums[0]?.benefitRenewalDate,
          frequency: _ctx.payment.frequency,
          "pro-rata": _ctx.proRata,
          "existing-pro-rata": _ctx.existingProRata,
          class: "mb-4"
        }, null, 8, ["payment-amount", "existing-payment-amount", "first-premium-date", "next-premium-date", "benefit-renewal-date", "frequency", "pro-rata", "existing-pro-rata"]))
      : _createCommentVNode("", true),
    _hoisted_5,
    _hoisted_6,
    _createElementVNode("p", null, _toDisplayString(_ctx.authorityMessage), 1),
    _createVNode(_component_SpecificConditions),
    _createVNode(_component_ConditionsOfThisAuthority, { "uses-generic-wording": true })
  ]))
}